export function navDropdown() {

    const $burger = $(".burger");
    const $html = $("html");
    const $body = $("body");
    const $searchResults = $(".search-panel .results");
    const $items = $(".main-menu > li");
    //const $btnTemplate = ``;
    const $header = $(".header");
    const $dropdowns = $(".main-menu > li > .dropdown");

    //navigation

    $burger.on("click", () => {
        if (window.innerWidth < 1200 && $html.hasClass("nav-opened")) {
            resetSearchInput();
            closeAllDropdowns();
        }
        $html.toggleClass("nav-opened");
    });

    $items.on("mouseenter", function () {
        if ($body.hasClass("no-touch") && window.innerWidth >= 1200) {
            $items.removeClass("current");

            if ($(this).find(".dropdown").length ) {

                $header.removeClass("show-searchbar");
                resetSearchInput();

                $header.addClass("revert-colors");
                $(this).addClass("current");
            }
        }
    });

    $header.on("mouseleave", function () {
        if ($body.hasClass("no-touch")) {
            if (window.innerWidth >= 1200) {

                $(this).removeClass("revert-colors");
                $(this).find("li.current").removeClass("current");

            }
        }
    });

    initDropdown();
    calcDropdownsHeight();

    $(window).on("resize", () => {
        calcDropdownsHeight();
    });

    $(document).on("click", ".main-menu > li > button", function () {

        if (!$(this).parent().hasClass("current")) {
            closeAllDropdowns();
            $(this).parent().addClass("current")
                .find(".dropdown").stop().slideDown();

            if (window.innerWidth >= 1200) {
                $header.addClass("revert-colors");
            }

        } else {
            closeAllDropdowns();

            if (window.innerWidth >= 1200) {
                $header.removeClass("revert-colors");
            }
        }

    });

    $(document).on("click", function (e) {
        if (!$(e.target).closest(".header .main-nav").length) {
            $header.removeClass("revert-colors");
            closeAllDropdowns();
        }
    });

    function calcDropdownsHeight() {

        if (window.innerWidth >= 1200) {
            $dropdowns.each((i, it) => {
                if ($(it).height() >= $(window).height() - $header.height()) {
                    $(it).addClass("auto-scroll");
                } else {
                    $(it).removeClass("auto-scroll");
                }
            });
        }
    }

    function initDropdown() {

        $items.each((i, it) => {
            if ($(it).find(".dropdown").length) {
                //$(it).append($btnTemplate);
            }
        });
    }

    function closeAllDropdowns() {
        $items.each((i, it) => {
            if ($(it).hasClass("current")) {
                $(it).removeClass("current").find(".dropdown").stop().fadeOut(100);
            }
           

        });
    }

    function resetSearchInput() {
        $searchResults.html("");
        $(".ais-SearchBox-input").val("");
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/nav-dropdown.js